import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getSalarys = async (queryParams = {}) => {
  const userinfo = localStorage.getItem("user");
  const userData = JSON.parse(userinfo);
  const token = userData.token;

  if (!token) {
    throw new Error("Token not found in local storage");
  }

  // Build query string from parameters
  const queryString = new URLSearchParams(
    Object.entries(queryParams).filter(([_, value]) => value !== "" && value !== undefined)
  ).toString();

  const url = queryString 
    ? `${base_url}salryrecord/?${queryString}`
    : `${base_url}salryrecord/`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

const createMonthSalary = async (paydata) => {
  const response = await axios.post(
    `${base_url}salryrecord/storemonthly`,
    paydata,
    config
  );
  return response.data;
};

const updateSalary = async (payment) => {
  const response = await axios.post(
    `${base_url}salryrecord/updateSalary`,
    payment,
    config
  );
  return response.data;
};

const updatePaidSalary = async (id, salaryData) => {
  try {
    const response = await axios.put(
      `${base_url}salryrecord/updatePaidSalary?id=${id}`,
      salaryData,
      config
    );
    return response.data;
  } catch (error) {
    // Extract backend error message - check multiple possible fields
    const errorMessage = error?.response?.data?.error ||      // Backend sends "error" field
                        error?.response?.data?.message || 
                        error?.response?.data?.msg || 
                        error?.message || 
                        "Request failed";
    throw {
      message: errorMessage,
      response: error.response,
      status: error?.response?.status
    };
  }
};

const deleteSalary = async (id) => {
  const response = await axios.delete(`${base_url}salryrecord`, {
    ...config,
    data: { id },
  });
  return response.data;
};

const deleteSalaryRecord = async (id) => {
  try {
    const response = await axios.delete(`${base_url}salryrecord`, {
      ...config,
      data: { id }, // Send ID in request body
    });
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.error ||      // Backend "error" field
                        error?.response?.data?.message || 
                        error?.response?.data?.msg || 
                        error?.message || 
                        "Request failed";
    throw {
      message: errorMessage,
      response: error.response,
      status: error?.response?.status
    };
  }
};

const csvDownload = async () => {
  const response = await axios.get(
    `${base_url}salryrecord/download-template`,
    config
  );
  return response.data;
};

const getOneSalary = async (id) => {
  const response = await axios.get(`${base_url}salryrecord/${id}`, config);
  return response.data;
};

const uploadCsv = async (params) => {
  try {
    // Create config for file upload - don't set Content-Type, let browser set it with boundary
    const uploadConfig = {
      headers: {
        Authorization: config.headers.Authorization,
        // Don't set Content-Type for FormData - browser will set it with boundary
      },
    };
    
    const response = await axios.post(
      `${base_url}salryrecord/storemonthlyViaFile`,
      params,
      uploadConfig
    );
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.error ||      // Backend "error" field
                        error?.response?.data?.message || 
                        error?.response?.data?.msg || 
                        error?.message || 
                        "Request failed";
    throw {
      message: errorMessage,
      response: error.response,
      status: error?.response?.status
    };
  }
};

const getUsersByStateAndDistrict = async ({ state_code, district }) => {
  const response = await axios.get(
    `${base_url}user/all-filter-users?state_code=${state_code}&district=${district}`,
    config
  );
  return response.data;
};

const salaryService = {
  getSalarys,
  createMonthSalary,
  updateSalary,
  updatePaidSalary,
  deleteSalary,
  deleteSalaryRecord, // Added new function
  csvDownload,
  uploadCsv,
  getOneSalary,
  getUsersByStateAndDistrict,
};

export default salaryService;
